"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{TopNavItem as m}from"./src/TopNavItem.js";e("sp-top-nav-item",m);
//# sourceMappingURL=sp-top-nav-item.js.map
